<template>
  <div class="funding-progress-indicator" :class="[`indicator--${size}`]">
    <img :alt="`${progress}%`" :src="computedImage">
  </div>
</template>

<script>
  export default {
    name: 'FundingProgressIndicator',
    props: {
      funded: {
        type: Number,
        required: true,
      },
      requested: {
        type: Number,
        required: true,
      },
      size: {
        type: String,
        default: 'small',
        validator: value => ['small', 'large'].includes(value),
      },
      status: {
        default: 'approved',
        type: String,
      },
    },
    data () {
      return {
        show: true,
      }
    },
    computed: {
      computedImage () {
        const defaultImage = `/img/loans/pies/${this.size}-pie-${this.progress}.svg`

        if (this.progress === 100) {
          switch (this.status) {
            case 'finished':
            case 'devalued':
              return `/img/loans/pies/${this.size}-pie-completed.svg`
            case 'funded':
            case 'repaying':
              return `/img/loans/pies/${this.size}-pie-funded.svg`
            default:
              return defaultImage
          }
        }

        return defaultImage
      },
      computedSize () {
        return this.size === 'large' ? 160 : 80
      },
      progress () {
        return Math.floor(this.funded * 100 / this.requested)
      },
      strokeWidth () {
        return this.size === 'large' ? 12 : 6
      },
    },
  }
</script>

<style lang="scss">
  @import "~assets/scss/frontend/_colours";
  @import "~foundation-sites/scss/util/_unit";

  .funding-progress-indicator {
    &.indicator--small {
    }

    &.indicator--large {
    }
  }
</style>

<style lang="scss" scoped>
  @import "~foundation-sites/scss/util/_mixins";
  @import "~foundation-sites/scss/util/_unit";
  @import "~foundation-sites/scss/util/_breakpoint";
  @import "~assets/scss/frontend/_colours";

  .funding-progress-indicator {
    position: relative;

    img {
      display: inline-block;
    }

    &.indicator--small {
      img {
        height: rem-calc(80);
        width: rem-calc(80);
      }
    }

    &.indicator--large {
      height: rem-calc(160);
      width: rem-calc(160);
    }
  }
</style>
